/**
 * Initializes a new instance of the `DailyCallManager` class, creating
 * a Daily.co call object and setting initial states for camera and
 * microphone muting, as well as the current room URL. It then calls the
 * `initialize` method to set up event listeners and UI interactions.
 */

import Daily from '@daily-co/daily-js';

var dailyCallManager = null;
var signaller_url = null;
var chat = null;

var chunckSize = 15000;             // Durata di ogni chunk di dati in millisec
// var chunckSize = 5000;             // Durata di ogni chunk di dati in millisec
var isTriaging = false;
var useS2TAScript = true;           // Utilizzo lo script per l'analisi del rawText invece del messaggio estratto dal chunck'


// GPT4 API Key - For GPT prompts
let apiKey = "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";
let organizationID = "org-0DAA8JsCW3lefCp1JEiycSHM";

// Speech-to-text
let Speech2Text_Openai_ApiKey = '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';

var activationKeywordsList = [
    "comando visitasmart",
    "comando visita smart",
    "comando smart",
    "comando start",
    "comando smooth",
    "comanda smart",
    "comando smap",
    "quando smart",
    "cosa smart",
    "come smart",
    "comodo smart",
    "comando s. m. a. r. t.",
    "comando s.m.a.r.t.",
    "cComando smesso",
];

var elencoComandi =  "Accendi torcia, 'Spegni torcia', Inizia triage, Termina triage, Conteggio pazienti, Elenco comandi";
// var elencoComandi =  "Scatta foto, Foto panoramica, Accendi torcia, Inizia triage, Termina triage, Conteggio pazienti, Cerca su internet, Chiedi all'AI, Elenco comandi";


var commandMap = {
    // "scatta foto": ["scatta foto", "scattafoto", "scatta una foto", "scatta fotografia", "scatta una fotografia", "fai una foto", "fai una fotografia" ],
    // "foto panoramica": ["foto panoramica", "fai foto panoramica", "fai fotografia panoramica", "scatta foto panoramica", "scatta fotografia panoramica"],
    "accendi torcia": ["accendi torcia", "accendi la torcia", "accendi la luce", "accendi la lampada", "accendi lampada", "accendi luce"],
    "spegni torcia": ["spegni torcia", "spegni la torcia", "spegni la luce", "spegni la lampada", "spegni lampada", "spegni luce", "spegne torcia", "spegni torcio", "spegne torcio"],
    "inizia triage": ['inizia il triage', 'e inizio a triaggio', 'avvia il triage', 'avvia il triaggio', ' inizia a reagire', 'comincia a triaggi', 'comincia il triage', 'inizio triage', 'inizia a triage', 'comincia triage', 'inizia triage', 'inizia a triaggi', 'comincia triaggio', 'comincia a triage', 'inizio il triage', 'inizia triaggio', 'comincia a reagire', 'avvia triage', 'avvia triaggio', 'comincia il triaggio', 'inizia il triaggio', 'inizio a triage', 'e inizio a triage', "inizio a triaggio", "inizio triaggio"],
    "termina triage": ['chiuso triage', 'a fine triage', 'triaggio terminato', 'termina il triage', 'triage chiuso', 'concluso il triaggio', 'conclusa triaggio', 'terminato triaggio', 'chiusa triage', 'conclusa la triage', 'terminato il triaggio', 'terminato il triage', 'concluso triage', 'chiusa la triaggio', 'finito', 'terminata triage', 'concluso triaggio', 'fine del triage', 'concludi triage', 'fine triaggio', 'termina il triaggio', 'concludi il triaggio', 'terminata la triaggio', 'fine del triaggio', 'conclusa la triaggio', 'chiusa triaggio', 'triaggio chiuso', 'termina a triaggio', 'triage terminato', 'concludi triaggio', 'termina triage', 'triaggio concluso', 'terminato triage', 'chiuso il triage', 'triage concluso', 'concludi il triage', 'concluso il triage', 'chiuso triaggio', 'chiuso il triaggio', 'terminata la triage', 'terminata triaggio', 'fine triage', 'conclusa triage', 'chiusa la triage', 'fino al triaggio', 'fine triascia', 'fine a triascia', 'fine della triascia', 'fine del triascia'],
    "conteggio pazienti":['conteggio pazienti', 'conteggio feriti', 'conta pazienti', 'contrapazienti', 'conta i pazienti', 'conta i feriti', 'conteggio soggetti', 'conteggio dei soggetti', 'conteggio dei pazienti', 'conta i soggetti', 'conteggio dei feriti', 'contapazienti', 'conta feriti', 'contaferiti', 'conta soggetti', 'contraferiti', "conteggi soggetti"],
    // "cerca su internet": ["cerca su internet", "cerca sul web", "effettua ricerca", "cerca informazioni", "cerca su google"],
    // "chiedi all'ai": ["chiedi all'ai", "chiedi all'intelligenza artificiale", "chiedi all'assistente virtuale", "chiedi all'assistente"],
    // "fine": ["termine", "fine", "stop", "termina", "concludi", "chiudi", "esci", "terminato", "concluso", "chiuso", "uscita", "uscito", "escito"],
    "elenco comandi": ["elenco comandi", "lista comandi", "aiuto comandi"]
};

// Var script S2TAScript
var comandiSpot = [];
var inizioTriageSinonimi = [];
var fineTriageSinonimi = [];
var triggerPossibili = null;
var testoAI = "";

// Variabili per tenere traccia delle trascrizioni
let ultimaPosizioneAnalizzataSpot = 0;
let ultimaPosizioneAnalizzataContinuos = 0;
let ultimaPosizioneTestoAI = 0;

var AIAllucinations = [
    "Al prossimo episodio",
    "Sottotitoli creati dalla comunit",
    "Sottotitoli e revisione a cura di QTSS",
    "Sottotitoli di Sottotitoli di Amara.org",
    "Sottotitoli e revisione al canale di Amara.org",
    "Sottotitoli e revisione a cura di Amara.org",
    "Sottotitoli e revisione a cura di QTSS.",
    "Sottotitoli a cura di QTSS",
    "Grazie per aver guardato questo video, iscriviti al nostro canale per non perderti i prossimi video",
    "aiutatevi a seguire il nostro corso gratuito www.mesmerism.info",
    "Sì. Sì. Sì. Sì. Sì.",
    "Grazie per la visione!",
    "Alla prossima!",
    "Grazie per aver guardato questo video, iscriviti al nostro canale, condividi e condividi.",
    "Grazie per aver guardato questo video, iscriviti al nostro canale",
    "Grazie a tutti per aver guardato questo video, non dimenticate di iscrivervi al canale per non perdere i prossimi video.",
    "Grazie per aver guardato questo video",
];

var promptsMap = {
    "countPatients": ["Ora sei un assistente virtuale per una sessione di esercitazione militare eseguita tramite un software. L'operatore ha comunicato questo testo, bisogna analizzarlo e creare una tabella html con il conteggio dei soggetti coinvolti. Restituisci solo l'html, senza introduzione e spiegazione finale. Rendi l'html con un design moderno e minimal. Il nostro colore predominante è #0085E4;. Ecco il testo da analizzare per generare la tabella HTML:"],
    "triageTable": ["Ora sei un assistente virtuale per una sessione di esercitazione militare eseguita tramite un software. Mi serve una tabella generata in HTML basata su un testo scritto da un operatore.  Restituisci solo l'html, senza introduzione e spiegazione finale. Rendi l'html con un design moderno e minimal. Il nostro colore predominante è #0085E4;. Ecco il testo da analizzare per generare la tabella HTML: "],
    "sessionRelationship": ["Ora sei un assistente per la creazione di una relazione su una sessione di esercitazione militare eseguita tramite un software. Ti manderò un testo da analizzare per creare una relazione e un riassunto su quello che è avvenuto durate la sessione. Rendi l'html con un design moderno e minimal. Il nostro colore predominante è #0085E4;. Ecco il testo da analizzare: "]
};

class DailyCallManager {

    constructor() {
      this.call = Daily.createCallObject();
      this.currentRoomUrl = null;
      this.count = 0;
      this.chunckSize = chunckSize, // Durata di ogni chunk di dati in millisec
      this.apiKey = Speech2Text_Openai_ApiKey;
      this.transcribeAudio = true;
      this.initialize();
      this.debugTranscription = false;
      this.debugAudioTracks = false;
      this.debugVerbose = false;
      this.debugSteps = false;
      this.participantTranscriptionStreams = new Map();
      this.operatorData = new Map(); // Mappa per memorizzare i dati degli operatori
      this.setupOperatorDataListeners();
    }

    /**
     * Performs initial setup of event listeners and UI component interactions.
     */
    async initialize() {
      this.setupEventListeners();
    }
  
    /** Aggiungo i Listner per gli eventi del Call Object */
    setupEventListeners() {
      const events = {
        'active-speaker-change': this.handleActiveSpeakerChange.bind(this),
        error: this.handleError.bind(this),
        'joined-meeting': this.handleJoin.bind(this),
        'left-meeting': this.handleLeave.bind(this),
        'participant-joined': this.handleParticipantJoined.bind(this),
        'participant-left': this.handleParticipantLeft.bind(this),
        'participant-updated': this.handleParticipantUpdated.bind(this),
      };

      Object.entries(events).forEach(([event, handler]) => {
            this.call.on(event, handler);
      });
    }

    /**
     * Handler for the local participant joining:
     * - Prints the room URL
     * - Enables the toggle camera, toggle mic, and leave buttons
     * - Gets the initial track states
     * - Sets up and enables the device selectors
     * @param {Object} event - The joined-meeting event object.
     */
    handleJoin(event) {
        /***************************** */
        /* SOLO LOCAL PARTICIPANT    * */
        /***************************** */
        if(this.debugSteps)
            console.log(`3. Successfully joined: ${this.currentRoomUrl}`);

        // Update the participant count
        this.updateAndDisplayParticipantCount();

        // Enable the leave button
        document.getElementById('leave-btn').disabled = false;
        document.getElementById('leave-btn').style = 'display: block;';

        // Enable record and trancribe buttons
        this.updateRecordTranscribeButtons(true, false, true, false);

        // Update the call state components in the UI
        this.updateUIButtons(true, true, false, false);

        // Set up the camera and mic selectors
        this.setupDeviceSelectors();

        // Aggiorno i tasti per la registrazione e lascio invairati quelli della trascrizione
        this.updateRecordTranscribeButtons(false, true, null, null);

        // Avvio la registrazione
        this.avviaRegistrazione();

        // Get the local participant's tracks
        const tracks = event.participants.local.tracks;
        // Initialize the camera and microphone states and UI for the local participant
        Object.entries(tracks).forEach(([trackType, trackInfo]) => {
            this.updateUiForDevicesState(trackType, trackInfo);
        });

    }
  


    handleParticipantJoined(event) {
        const { participant } = event;
        const participantId = participant.session_id;
        const participantName = participant.user_name;
        const isLocal = participant.local;
        const tracks = participant.tracks;

        // Collegamento con exercise.blade.php per la mappatura
        if (window.onParticipantJoined) {
            window.onParticipantJoined(participantId);
        }

        console.log(`6. Participant ${participantName} JOINED`);


        if(this.debugSteps)
            console.log(`6. Participant ${participantName} JOINED`);
    
        // Always update the participant count regardless of the event action
        this.updateAndDisplayParticipantCount();
    
        // Create a video container if one doesn't exist
        if (!document.getElementById(`video-container-${participantId}`)) {
            this.createVideoContainer(participantId);
        }
    
        // Create an audio element for non-local participants if one doesn't exist
        if (!document.getElementById(`audio-${participantId}`) && !isLocal) {
            this.createAudioElement(participantId);
        }

        // Update the participant's tracks and UI based on the event action
        Object.entries(tracks).forEach(([trackType, trackInfo]) => {


            if (trackInfo.persistentTrack) {
                // Check if this is the local participant's audio track. If so, we will skip playing it, as it's already being played. We'll start or update tracks in all other cases.
                if (!(isLocal && trackType === 'audio')) {
                    this.startOrUpdateTrack(trackType, trackInfo, participantId);
                }

            } else {
                // If the track is not available, remove the media element
                this.destroyTracks([trackType], participantId);
            }
    
            // Update the video UI based on the track's state
            if (trackType === 'video') {
                this.updateVideoUi(trackInfo, participantId);
            }
    
            // Update the camera and microphone states for the local user based on the track's state
            if (isLocal) {
                this.updateUiForDevicesState(trackType, trackInfo);
            }
        });

        // Inizializza i dati dell'operatore
        this.operatorData.set(participantId, {
            operatorName: participantName || `Operatore ${participantId}`,
            bpm: '--',
            bpmMax: '--',
            distance: '--',
            speed: '--',
            movement: '--',
            energy: '--'
        });

        // Aggiorna l'overlay con i dati iniziali
        updateOperatorOverlay(participantId, this.operatorData.get(participantId));
    }

    handleParticipantUpdated(event) {
        const { participant } = event;
        const participantId = participant.session_id;
        const participantName = participant.user_name;
        const isLocal = participant.local;
        const tracks = participant.tracks;

        console.log(`6. Participant ${participantName} UPDATED`);


        if(this.debugSteps)
            console.log(`6. Participant ${participantName} UPDATED`);
    
        // Always update the participant count regardless of the event action
        this.updateAndDisplayParticipantCount();
    
        // Create a video container if one doesn't exist
        if (!document.getElementById(`video-container-${participantId}`)) {
            this.createVideoContainer(participantId);
        }
    
        // Create an audio element for non-local participants if one doesn't exist
        if (!document.getElementById(`audio-${participantId}`) && !isLocal) {
            this.createAudioElement(participantId);
        }

        // Update the participant's tracks and UI based on the event action
        Object.entries(tracks).forEach(([trackType, trackInfo]) => {


            if (trackInfo.persistentTrack) {
                // Check if this is the local participant's audio track. If so, we will skip playing it, as it's already being played. We'll start or update tracks in all other cases.
                if (!(isLocal && trackType === 'audio')) {
                    this.startOrUpdateTrack(trackType, trackInfo, participantId);
                }

                if(this.debugVerbose)
                    console.log("transcribeAudio: ", this.transcribeAudio);

                // if (isLocal && trackType === 'audio' && trackInfo.state === 'playable' && this.transcribeAudio) {
                if (trackType === 'audio' && trackInfo.state === 'playable' && this.transcribeAudio) {

                    if(this.debugAudioTracks){
                        console.log("Canale audio del local participant: ", participantName);

                        if(this.debugVerbose)
                            console.log("trackInfo: ", trackInfo);
                    
                    }

                    // TRASCRIZIONE
                    // Se la trascrizione è già attiva per il partecipante, non la riattivo
                    // if(!(this.participantTranscriptionStreams.has(participantId) && this.participantTranscriptionStreams.get(participantId) == true)) {
                    //     let audioStream = new MediaStream([trackInfo.persistentTrack]);
                    //     this.handleAudioStream(audioStream, participantId, participantName);
                    //     this.participantTranscriptionStreams.set(participantId, true);
                    // }

                    if(!(this.participantTranscriptionStreams.has(participantId) && this.participantTranscriptionStreams.get(participantId) != null)) {
                        let audioStream = new MediaStream([trackInfo.persistentTrack]);
                        this.handleAudioStream(audioStream, participantId, participantName);
                        // this.participantTranscriptionStreams.set(participantId, true);
                        this.participantTranscriptionStreams.set(participantId, audioStream);
                    } else {
                        console.log("Trascrizione già attiva per: ", participantName);
                        //let tmpStream = partecipantTranscriptionStreams.get(participantId)
                        //this.handleAudioStream( this.participantTranscriptionStreams.get(participantId), participantId, participantName);
                        if(this.participantTranscriptionStreams.has(participantId) && this.participantTranscriptionStreams.get(participantId) != null) {
                            console.log("Trascrizione già attiva per: ", participantName+" - "+this.participantTranscriptionStreams.get(participantId));
                            let participantAudioStream = this.participantTranscriptionStreams.get(participantId);
                            console.log(participantAudioStream.getTracks());

                             let actualTracks = participantAudioStream.getTracks();
                            // // Ciclare su tutte le tracce e rimuovere quelle con readyState 'ended'
                            // actualTracks.forEach(track => {
                            //     if (track.readyState === "ended") {
                            //         participantAudioStream.removeTrack(track);
                            //         console.log('Rimossa traccia terminata:', track);
                            //     }
                            // });

                            // let audioStream = new MediaStream([trackInfo.persistentTrack]);
                            // this.handleAudioStream(audioStream, participantId, participantName);
                            // // this.participantTranscriptionStreams.set(participantId, true);
                            // this.participantTranscriptionStreams.set(participantId, audioStream);

                            // console.log("Original Track: ", actualTracks[0]);
                            // console.log("Aggiungo la persistentTrack: ", trackInfo.persistentTrack);
                            console.log(actualTracks[0].id);
                            console.log(trackInfo.persistentTrack.id);

                            if(actualTracks[0].id != trackInfo.persistentTrack.id) {

                                console.log("&&&&&&&&&&&&&&&&&&&&&&&& ");

                                actualTracks.forEach(track => {
                                    if (track.readyState === "ended") {
                                        participantAudioStream.removeTrack(track);
                                        console.log('Rimossa traccia terminata:', track);
                                    }
                                });

                                participantAudioStream.addTrack(trackInfo.persistentTrack);
                                this.handleAudioStream(participantAudioStream, participantId, participantName);
                                // this.participantTranscriptionStreams.set(participantId, true);
                                this.participantTranscriptionStreams.set(participantId, participantAudioStream);
                            }

       
                        }
                    }


                }

            } else {
                // If the track is not available, remove the media element
                this.destroyTracks([trackType], participantId);
            }
    
            // Update the video UI based on the track's state
            if (trackType === 'video') {
                this.updateVideoUi(trackInfo, participantId);
            }
    
            // Update the camera and microphone states for the local user based on the track's state
            if (isLocal) {
                this.updateUiForDevicesState(trackType, trackInfo);
            }
        });
    }


    /* Do the magic */
    handleAudioStream(stream, participantId, participantName = null) {

        if(this.debugAudioTracks)
            console.log("8. Attivo la trascrizione per: ", participantName);

        // Opzioni per la registrazione in MP3
        const recorder = new RecordRTC(stream, {
            type: 'audio',
            mimeType: 'audio/webm',  // Utilizza webm come sorgente
            recorderType: RecordRTC.StereoAudioRecorder, // Utilizza il registratore stereo
            desiredSampRate: 44100,  // Frequenza di campionamento desiderata per l'output MP3
            numberOfAudioChannels: 1, // Numero di canali audio
            timeSlice: this.chunckSize, // Durata di ogni chunk di dati
            ondataavailable: async function(blob) {

                // downloadMP3(blob, participantId);

                const formData = new FormData();
                formData.append('model', 'whisper-1');
                formData.append('language', 'it');
                formData.append('file', blob, `recording_${participantId}.mp3`);

                const openAiUrl = 'https://api.openai.com/v1/audio/transcriptions';
                const apiKey = Speech2Text_Openai_ApiKey;
                try {
                    const response = await fetch(openAiUrl, {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${apiKey}`,
                        },
                        body: formData
                    });
    
                    const result = await response.json();
                    if (response.ok) {

                        if(this.debugTranscription)
                            console.log(participantName, result['text']);

                        gestisciMessaggioTrascrizione(result['text'], participantName);

                    } else {
                        console.error('Failed to transcribe:', result);
                    }
                } catch (error) {
                    console.error('Error calling OpenAI API:', error);
                }
            }
        });
    
        recorder.startRecording();
    
        document.getElementById('leave-btn').addEventListener('click', () => {
            recorder.stopRecording(function() {
                let blob = recorder.getBlob();
                // gestire il blob finale se necessario
            });
        });
    }


        /**
         * Updates the UI with the current active speaker's identity.
         * @param {Object} event - The active speaker change event object.
         */
        handleActiveSpeakerChange(event) {
        document.getElementById(
            'active-speaker'
        ).textContent = `Active Speaker: ${event.activeSpeaker.peerId}`;
        }

        /**
         * Handler for participant leave events:
         * - Disable the toggle camera and mic buttons
         * - Resets the camera and mic selectors
         * - Updates the call state in the UI
         * - Removes all video containers
         */
        handleLeave() {

            if(this.debugSteps)
                console.log('7. Successfully left the call');

            // Update the join and leave button states
            document.getElementById('leave-btn').disabled = true;
            document.getElementById('leave-btn').style = 'display: none;';
            // Update the call state components in the UI()
            this.updateUIStateComponents("off", "off", "0", "None");
    
                // Update the UI buttons (disable toggle camera and mic buttons and selectors)
            this.updateUIButtons(false, false, false, false);
        
            // Remove all video containers
            const multiVideoCallContainer = document.getElementById('multiVideoCallContainer');
            while (multiVideoCallContainer.firstChild) {
                multiVideoCallContainer.removeChild(multiVideoCallContainer.firstChild);
            }
        }


        /**
         * Handles fatal errors emitted from the Daily call object.
         * These errors result in the participant leaving the meeting. A
         * `left-meeting` event will also be sent, so we still rely on that event
         * for cleanup.
         * @param {Object} e - The error event object.
         */
        handleError(e) {
          console.error('DAILY SENT AN ERROR!', e.error ? e.error : e.errorMsg);
        }

        /**
         * Handles participant-left event:
         * - Cleans up the video and audio tracks for the participant
         * - Removes the related UI elements
         * @param {Object} event - The participant-left event object.
         */
        handleParticipantLeft(event) {
          const participantId = event.participant.session_id;
      
          // Clean up the video and audio tracks for the participant
          this.destroyTracks(['video', 'audio'], participantId);
      
          // Now, remove the related video UI
          document.getElementById(`video-container-${participantId}`)?.remove();
      
          // Update the participant count
          this.updateAndDisplayParticipantCount();

          // Rimuovi i dati dell'operatore
          this.operatorData.delete(participantId);
        }


    /**
     * Tries to join a call with provided room URL and optional join token.
     * @param {string} roomUrl - The URL of the room to join.
     * @param {string|null} joinToken - An optional token for joining the room.
     */
    async joinRoom(roomUrl, joinToken = null) {
      if (!roomUrl) {
        console.error('Room URL is required to join a room.');
        return;
      }
  
    this.currentRoomUrl = roomUrl;
  
    const joinOptions = { 
        url: roomUrl, 
        userName: 'Control Room' 
    };

      if (joinToken) {
        joinOptions.token = joinToken;
        if(this.debugSteps)
            console.log('1. Joining with a token.');
      } else {
        if(this.debugSteps)
            console.log('1. Joining without a token.');
      }
  
      try {
        // Disable the join button to prevent multiple attempts to join
        document.getElementById('joinBTN').disabled = true;
        document.getElementById('joinBTN').style = 'display: none;';

        // Join the room
        await this.call.join(joinOptions);

      } catch (e) {
        console.error('Join failed:', e);
      }
    }
  
    /**
     * Creates and sets up a new video container for a specific participant. This
     * function dynamically generates a video element along with a container and
     * an overlay displaying the participant's ID. The newly created elements are
     * appended to a designated parent in the DOM, preparing them for video
     * streaming or playback related to the specified participant.
     *
     * @param {string} participantId - The unique identifier for the participant.
     */
    createVideoContainer(participantId) {
        // Crea un container per il video del partecipante
        const videoContainer = document.createElement('div');
        videoContainer.id = `video-container-${participantId}`;

        const isLocalParticipant = this.call.participants().local.session_id === participantId;

        // La classe video-container usa ora CSS Grid dinamico per layout responsive tipo Google Meet
        videoContainer.className = `video-container${isLocalParticipant ? ' control-room-preview' : ''}`;
      
        // Otteniamo il container multi-video
        const multiVideoCallContainer = document.getElementById('multiVideoCallContainer');
        multiVideoCallContainer.appendChild(videoContainer);
      
        // Aggiunta di un overlay per visualizzare il session ID del partecipante
        const sessionIdOverlay = document.createElement('div');
        sessionIdOverlay.className = 'session-id-overlay';
        sessionIdOverlay.textContent = participantId;
        videoContainer.appendChild(sessionIdOverlay);
      
        console.log("CREO IL CONTAINERRRRRREREAF") 
               // Overlay statico custom
        const videoOverlay = document.createElement('div');
        videoOverlay.id = `operator-overlay-${participantId}`; // Aggiungo un ID univoco
        videoOverlay.className = 'video-overlay-custom';
        if (isLocalParticipant) {
            // Solo header con nome fisso
            videoOverlay.innerHTML = `
                <div class="overlay-header">
                    <span class="operator-icon" style="vertical-align: middle;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-person-circle" viewBox="0 0 16 16">
                            <path d="M11 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/>
                            <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 1 0 0 14A7 7 0 0 0 8 1z"/>
                        </svg>
                    </span>
                    <span class="operator-name" style="margin-left: 8px; font-weight: bold;">Control Room</span>
                </div>
            `;
        } else {
            // Overlay completo per gli altri operatori (footer fisso, griglia orizzontale)
            videoOverlay.innerHTML = `
                <div class="overlay-header">
                    <span class="operator-icon" style="vertical-align: middle;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-person-circle" viewBox="0 0 16 16">
                            <path d="M11 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/>
                            <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 1 0 0 14A7 7 0 0 0 8 1z"/>
                        </svg>
                    </span>
                    <span class="operator-name" style="margin-left: 8px; font-weight: bold;">Caricamento...</span>
                </div>
                <div class="overlay-footer overlay-footer-grid custom-overlay-footer">
                    <div class="overlay-value-custom" data-metric="bpm">
                        <div class="overlay-row">
                            <svg class="btn-icon-prepend" width="24" height="24" style="width: auto; height: auto; position: unset">
                                <use xlink:href="/assets/icons/bootstrap-icons.svg#heart-fill"/>
                            </svg>
                            <span class="bpm-value overlay-value-number">--</span>
                        </div>
                        <div class="overlay-label">BPM</div>
                    </div>
                    <div class="overlay-value-custom" data-metric="bpm-max">
                        <div class="overlay-row">
                            <svg class="btn-icon-prepend" width="24" height="24" style="width: auto; height: auto; position: unset">
                                <use xlink:href="/assets/icons/bootstrap-icons.svg#heart-pulse"/>
                            </svg>
                            <span class="bpm-max-value overlay-value-number">--</span>
                        </div>
                        <div class="overlay-label">BPM Max</div>
                    </div>
                    <div class="overlay-value-custom" data-metric="distance">
                        <div class="overlay-row">
                            <svg class="btn-icon-prepend" width="24" height="24" style="width: auto; height: auto; position: unset">
                                <use xlink:href="/assets/icons/bootstrap-icons.svg#universal-access"/>
                            </svg>
                            <span class="distance-value overlay-value-number">--</span>
                        </div>
                        <div class="overlay-label">Distanza</div>
                    </div>
                    <div class="overlay-value-custom" data-metric="speed">
                        <div class="overlay-row">
                            <svg class="btn-icon-prepend" width="24" height="24" style="width: auto; height: auto; position: unset">
                                <use xlink:href="/assets/icons/bootstrap-icons.svg#speedometer2 "/>
                            </svg>
                            <span class="speed-value overlay-value-number">--</span>
                        </div>
                        <div class="overlay-label">Velocità</div>
                    </div>
                    <div class="overlay-value-custom" data-metric="movement">
                        <div class="overlay-row">
                            <svg class="btn-icon-prepend" width="24" height="24" style="width: auto; height: auto; position: unset">
                                <use xlink:href="/assets/icons/bootstrap-icons.svg#universal-access-circle"/>
                            </svg>
                            <span class="movement-value overlay-value-number">--</span>
                        </div>
                        <div class="overlay-label">Movimento</div>
                    </div>
                    <div class="overlay-value-custom" data-metric="energy">
                        <div class="overlay-row">
                            <svg class="btn-icon-prepend" width="24" height="24" style="width: auto; height: auto; position: unset">
                                <use xlink:href="/assets/icons/bootstrap-icons.svg#fire"/>
                            </svg>
                            <span class="energy-value overlay-value-number">--</span>
                        </div>
                        <div class="overlay-label">Calorie</div>
                    </div>
                </div>
            `;
        }
        videoContainer.appendChild(videoOverlay);
      
        // Creazione dell'elemento video per il partecipante
        const videoEl = document.createElement('video');
        videoEl.className = 'video-element';
      
        // ESEMPIO: Applica la classe vertical-video se l'id contiene 'vertical' (sostituisci con logica reale se vuoi)
        if (participantId && participantId.toLowerCase().includes('vertical')) {
            videoContainer.classList.add('vertical-video');
            videoEl.classList.add('vertical-video');
        }

        // Se il video è locale e sono presenti più partecipanti, applica alcuni stili
        videoContainer.appendChild(videoEl);
    }

    /**
     * Creates an audio element for a particular participant. This function is
     * responsible for dynamically generating a standalone audio element that can
     * be used to play audio streams associated with the specified participant.
     * The audio element is appended directly to the document body or a relevant
     * container, thereby preparing it for playback of the participant's audio.
     *
     * @param {string} participantId - A unique identifier corresponding to the participant.
     */
    createAudioElement(participantId) {
      // Create an audio element for the participant
      const audioEl = document.createElement('audio');
      audioEl.id = `audio-${participantId}`;
      document.body.appendChild(audioEl);
    }
  
    /**
     * Updates the media track (audio or video) source for a specific participant
     * and plays the updated track. It checks if the source track needs to be
     * updated and performs the update if necessary, ensuring playback of the
     * media track.
     *
     * @param {string} trackType - Specifies the type of track to update ('audio' or 'video'), allowing the function to dynamically adapt to the track being processed.
     * @param {Object} track - Contains the media track data, including the `persistentTrack` property which holds the actual MediaStreamTrack to be played or updated.
     * @param {string} participantId - Identifies the participant whose media track is being updated.
     */
    startOrUpdateTrack(trackType, track, participantId) {
      // Construct the selector string or ID based on the trackType.
      const selector =
        trackType === 'video'
          ? `#video-container-${participantId} video.video-element`
          : `audio-${participantId}`;
  
      // Retrieve the specific media element from the DOM.
      const trackEl =
        trackType === 'video'
          ? document.querySelector(selector)
          : document.getElementById(selector);
  
      // Error handling if the target media element does not exist.
      if (!trackEl) {
        console.error(
          `${trackType} element does not exist for participant: ${participantId}`
        );
        return;
      }
  
      // Check for the need to update the media source. This is determined by
      // checking whether the existing srcObject's tracks include the new
      // persistentTrack. If there are no existing tracks or the new track is not
      // among them, an update is necessary.
      const existingTracks = trackEl.srcObject?.getTracks();
      const needsUpdate = !existingTracks?.includes(track.persistentTrack);
  
      // Perform the media source update if needed by setting the srcObject of
      // the target element to a new MediaStream containing the provided
      // persistentTrack.
      if (needsUpdate) {
            trackEl.srcObject = new MediaStream([track.persistentTrack]);
  
        // Once the media metadata is loaded, attempts to play the track. Error
        // handling for play failures is included to catch and log issues such as
        // autoplay policies blocking playback.
        trackEl.onloadedmetadata = () => {
          trackEl
            .play()
            .catch((e) =>
              console.error(
                `Error playing ${trackType} for participant ${participantId}:`,
                e
              )
            );
        };
      }
    }
  
    /**
     * Shows or hides the video element for a participant, including managing
     * the visibility of the video based on the track state.
     * @param {Object} track - The video track object.
     * @param {string} participantId - The ID of the participant.
     */
    updateVideoUi(track, participantId) {
      let videoEl = document
        .getElementById(`video-container-${participantId}`)
        .querySelector('video.video-element');
  
      switch (track.state) {
        case 'off':
        case 'interrupted':
        case 'blocked':
          videoEl.style.display = 'none'; // Hide video but keep container
          break;
        case 'playable':
        default:
          // Here we handle all other states the same as we handle 'playable'.
          // In your code, you may choose to handle them differently.
          videoEl.style.display = '';
          break;
      }
    }
  
    /**
     * Cleans up specified media track types (e.g., 'video', 'audio') for a given
     * participant by stopping the tracks and removing their corresponding
     * elements from the DOM. This is essential for properly managing resources
     * when participants leave or change their track states.
     * @param {Array} trackTypes - An array of track types to destroy, e.g.,
     * ['video', 'audio'].
     * @param {string} participantId - The ID of the participant.
     */
    destroyTracks(trackTypes, participantId) {
      trackTypes.forEach((trackType) => {
        const elementId = `${trackType}-${participantId}`;
        const element = document.getElementById(elementId);
        if (element) {
          element.srcObject = null; // Release media resources
          element.parentNode.removeChild(element); // Remove element from the DOM
        }
      });
    }

    toggleCamera() {
      this.call.setLocalVideo(!this.call.localVideo());
    }
  
    toggleMicrophone() {
      this.call.setLocalAudio(!this.call.localAudio());
    }


    /* Update UI State Components */
    updateUIStateComponents(cameraState = null, micState = null, participantCount = null, activeSpeaker = null) {


        if(!cameraState) {
            document.getElementById('camera-state').style = 'display: none;'
        } else {
            if(cameraState && cameraState === 'on') {
                document.getElementById('camera-state').textContent = 'Camera: On';
            } else {
            document.getElementById('camera-state').textContent = 'Camera: Off';
            }
        }

        if(!micState) {
            document.getElementById('mic-state').style = 'display: none;'
        } else {
            if(micState && micState === 'on') {
                document.getElementById('mic-state').textContent = 'Mic: On';
            } else {
                document.getElementById('mic-state').textContent = 'Mic: Off';
            }
        }

        if(!participantCount) {
            document.getElementById('participant-count').style = 'display: none;'
        } else {
            document.getElementById('participant-count').textContent = `Participants: ${participantCount}`;
        }

        if(!activeSpeaker) {
            document.getElementById('active-speaker').style = 'display: none;'
        } else {
            document.getElementById('active-speaker').textContent = `Active Speaker: ${activeSpeaker}`;
        }

 

    }

    /** Update UI Buttons Camera & Mic*/
    updateUIButtons(toggleCamera = null, toggleMic = null, cameraSelector = null, micSelector = null) {

        let cameraSelectorComponent = document.getElementById('camera-selector');
        let micSelectorComponent = document.getElementById('mic-selector');
        let toggleCameraComponent = document.getElementById('toggle-camera');
        let toggleMicComponent = document.getElementById('toggle-mic');

        let cameraIcon = document.getElementById('camera-icon');
        let micIcon = document.getElementById('mic-icon');
        document.getElementById('camera-icon').style = 'display: none;';
        document.getElementById('mic-icon').style = 'display: none;';

        // Toggle camera and mic buttons
        if(!toggleCamera) {
            toggleCameraComponent.disabled = true;
            toggleCameraComponent.style = 'display: none;'
        } else {
            toggleCameraComponent.disabled = false;
            toggleCameraComponent.style = 'display: block;'
        }

        if(!toggleMic) {
            toggleMicComponent.disabled = true;
            toggleMicComponent.style = 'display: none;'
        } else {
            toggleMicComponent.disabled = false;
            toggleMicComponent.style = 'display: block;'
        }

        // Camera and Mic selectors
        if(!cameraSelector) {
            cameraSelectorComponent.disabled = true;
            cameraSelectorComponent.style = 'display: none;';
            // cameraSelectorComponent.selectedIndex = 0;
            cameraIcon.style = 'display: none;';
            cameraIcon.disabled = true;
        } else {
            cameraSelectorComponent.disabled = false;
            // cameraSelectorComponent.style = 'display: block;';
            cameraIcon.style = 'display: block;';
            cameraIcon.disabled = false;
        }

        if(!micSelector) {
            micSelectorComponent.disabled = true;
            micSelectorComponent.style = 'display: none;';
            // micSelectorComponent.selectedIndex = 0;
            micIcon.style = 'display: none;';
            micIcon.disabled = true;
        } else {
            micSelectorComponent.disabled = false;
            // micSelectorComponent.style = 'display: block;';
            micIcon.style = 'display: block;';
            micIcon.disabled = false;
        }
    
    }

    updateRecordTranscribeButtons(avviaRegistrazione = null, terminaRegistrazione = null, avviaTrascrizione = null, terminaTrascrizione = null) {
    
        let avviaRegistrazioneBTN = document.getElementById('avviaRegistrazioneBTN');
        let terminaRegistrazioneBTN = document.getElementById('terminaRegistrazioneBTN');

        if(avviaRegistrazione != null) {
            if(!avviaRegistrazione) {
                avviaRegistrazioneBTN.disabled = true;
                avviaRegistrazioneBTN.style = 'display: none;';
            } else {
                avviaRegistrazioneBTN.disabled = false;
                avviaRegistrazioneBTN.style = 'display: inline;';
            }
        }

        if(terminaRegistrazione != null) {
            if(!terminaRegistrazione) {
                terminaRegistrazioneBTN.disabled = true;
                terminaRegistrazioneBTN.style = 'display: none;';
            } else {
                terminaRegistrazioneBTN.disabled = false;
                terminaRegistrazioneBTN.style = 'display: inline;';
            }
        }
    }

    /**
     * Updates the UI to reflect the current states of the local participant's
     * camera and microphone.
     * @param {string} trackType - The type of track, either 'video' for cameras
     * or 'audio' for microphones.
     * @param {Object} trackInfo - The track object.
     */
    updateUiForDevicesState(trackType, trackInfo) {
      // For video, set the camera state
      if (trackType === 'video') {
        document.getElementById('camera-state').textContent = `Camera: ${
          this.call.localVideo() ? 'On' : 'Off'
        }`;
      } else if (trackType === 'audio') {
        // For audio, set the mic state
        document.getElementById('mic-state').textContent = `Mic: ${
          this.call.localAudio() ? 'On' : 'Off'
        }`;
      }
    }

    /**
     * Sets up device selectors for cameras and microphones by dynamically
     * populating them with available devices and attaching event listeners to
     * handle device selection changes.
     */
    async setupDeviceSelectors() {

         // Richiedi i permessi
        const permissionsGranted = await requestMediaAccess();
        if (!permissionsGranted) {
            console.error("Impossibile ottenere i permessi, impossibile popolare i dispositivi.");
            return;
        }

        // Fetch current input devices settings and an array of available devices.
        const selectedDevices = await this.call.getInputDevices();
        const { devices: allDevices } = await this.call.enumerateDevices();
    
        // Element references for camera and microphone selectors.
        const selectors = {
            videoinput: document.getElementById('camera-selector'),
            audioinput: document.getElementById('mic-selector'),
        };

        // Create and append options to the selectors based on available devices.
        allDevices.forEach((device) => {
            if (device.label && selectors[device.kind]) {
            const isSelected =
                selectedDevices[device.kind === 'videoinput' ? 'camera' : 'mic']
                .deviceId === device.deviceId;
            const option = new Option(
                device.label,
                device.deviceId,
                isSelected,
                isSelected
            );
            selectors[device.kind].appendChild(option);
            }
        });

        // Listen for user device change requests.
        Object.entries(selectors).forEach(([deviceKind, selector]) => {
            selector.addEventListener('change', async (e) => {
            const deviceId = e.target.value;
            const deviceOptions = {
                [deviceKind === 'videoinput' ? 'videoDeviceId' : 'audioDeviceId']:
                deviceId,
            };
            await this.call.setInputDevicesAsync(deviceOptions);
            });
        });
    }


  
    /**
     * Updates the UI with the current number of participants.
     * This method combines getting the participant count and updating the UI.
     * Inoltre aggiorna dinamicamente il layout della griglia video tipo Google Meet
     */
    updateAndDisplayParticipantCount() {
      const participantCount =
        this.call.participantCounts().present +
        this.call.participantCounts().hidden;
      document.getElementById(
        'participant-count'
      ).textContent = `Participants: ${participantCount}`;
      
      // Aggiorna il layout della griglia video dinamicamente
      this.updateVideoGridLayout(participantCount);
    }
    
    /**
     * Aggiorna dinamicamente il layout della griglia video in base al numero di partecipanti
     * Layout tipo Google Meet: 1, 2x1, 2x2, 3x2, 3x3, etc.
     * @param {number} participantCount - Numero di partecipanti
     */
    updateVideoGridLayout(participantCount) {
      const container = document.getElementById('multiVideoCallContainer');
      if (!container) return;
      
      // Rimuovi tutte le classi precedenti di participant count
      container.classList.remove('participants-1', 'participants-2', 'participants-3', 
                                 'participants-4', 'participants-5', 'participants-6', 
                                 'participants-many');
      
      // Aggiungi la classe appropriata in base al numero di partecipanti
      if (participantCount === 1) {
        container.classList.add('participants-1');
      } else if (participantCount === 2) {
        container.classList.add('participants-2');
      } else if (participantCount === 3) {
        container.classList.add('participants-3');
      } else if (participantCount === 4) {
        container.classList.add('participants-4');
      } else if (participantCount === 5) {
        container.classList.add('participants-5');
      } else if (participantCount === 6) {
        container.classList.add('participants-6');
      } else {
        container.classList.add('participants-many');
      }
    }
  
    /**
     * Leaves the call and performs necessary cleanup operations like removing
     * video elements.
     */
    async leave() {
      try {

        await this.call.leave();

        // Rimuove tutti i video e audio element
        document.querySelectorAll('#multiVideoCallContainer video, audio').forEach((el) => {
          el.srcObject = null; // Release media resources
          el.remove(); // Remove the element from the DOM
        });
      } catch (e) {
        console.error('Leaving failed', e);
      }
    }

    async avviaRegistrazione() {
        console.log("Avvio registrazione");

        // Start a recording with a specific layout
        await this.call.startRecording({
            // instanceId: 'ad2ecf4e-09d9-11ef-98c3-325096b39f47', // optional: default value
            width: 1280,
            height: 720,
            fps: 25,
            backgroundColor: '#FF1F2D3D',
            layout: {
                preset: 'active-participant',
                // max_cam_streams: 5,
            },
        });
      
    }

    terminaRegistrazione() {
        console.log("Fermo registrazione");
        this.call.stopRecording();
    }

    /**
     * Aggiorna i dati di un operatore
     * @param {string} participantId - ID del partecipante
     * @param {Object} newData - Nuovi dati da aggiornare
     */
    updateOperatorData(participantId, newData) {
        if (!this.operatorData.has(participantId)) {
            this.operatorData.set(participantId, {});
        }

        const currentData = this.operatorData.get(participantId);
        const updatedData = { ...currentData, ...newData };
        this.operatorData.set(participantId, updatedData);

        // Aggiorna l'overlay con i nuovi dati
        updateOperatorOverlay(participantId, updatedData);
    }

    setupOperatorDataListeners() {
        // Ascolta gli eventi di aggiornamento dei dati degli operatori
        this.call.on('operator-data-update', (event) => {
            const { participantId, data } = event;
            this.updateOperatorData(participantId, data);
        });

        // Ascolta gli eventi di aggiornamento in tempo reale
        this.call.on('operator-realtime-update', (event) => {
            const { participantId, data } = event;
            this.updateOperatorData(participantId, data);
        });
    }

}


// Funzione per richiedere i permessi a fotocamera e microfono
async function requestMediaAccess() {
    try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        // Se non ti serve utilizzare lo stream, fermalo subito
        stream.getTracks().forEach(track => track.stop());
        return true;
    } catch (err) {
        console.error("Permessi per accesso a fotocamera e microfono non concessi:", err);
        return false;
    }
    }

async function getAdminToken() {

    const DAILY_API_KEY = "a15a590fd680c79e966177e3be2fadb4f11bdadc81ce1f4e26c18f98e80f14fa";
    const DAILY_ROOM_NAME = "ITA_1";

    const getAdminTokenBTN = document.getElementById("getAdminTokenBTN");
    getAdminTokenBTN.innerHTML = "...";
    getAdminTokenBTN.disabled = true;

    // TODO: Attezione scade dopo 1 ora
    const exp = Math.floor(Date.now() / 1000) + 3600; // Tempo corrente in secondi più 3600 secondi

    const response = await fetch('https://api.daily.co/v1/meeting-tokens', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${DAILY_API_KEY}`
        },
        body: JSON.stringify({
            properties: {
                room_name: DAILY_ROOM_NAME,
                is_owner: true,
                exp: exp
            }
        })
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    } else {
        const tokenData = await response.json(); // Attesa della risoluzione della Promise
        // console.log("Token ottenuto con successo");

        const tokenValue = tokenData.token;
        const adminTokenContainer = document.getElementById("adminTokenContainer");
        adminTokenContainer.value = tokenValue;

        // Nascondo il pulsante di ottenimento del token
        getAdminTokenBTN.style.display = "none";

        // // Mostro il pulsante successivo
        const joinBTN = document.getElementById("joinBTN");
        joinBTN.style.display = "inline";
        joinBTN.disabled = false;


        //*************************************** */
        const roomUrl = document.getElementById('roomURL').value.trim();
        const joinToken = document.getElementById('adminTokenContainer').value.trim() || null;

        document.getElementById('joinBTN').disabled = true;
        document.getElementById('joinBTN').style = 'display: none;';

        let videoCardContainer = document.getElementById('videoCardContainer');
        videoCardContainer.style.display = "block";

        if(!dailyCallManager){
            dailyCallManager = new DailyCallManager();
            dailyCallManager.setupDeviceSelectors();
        }

        // this.updateUIButtons(toggleCamera = null, toggleMic = null, cameraSelector = null, micSelector = null);
        dailyCallManager.updateUIButtons(false, false, false, false);

        await dailyCallManager.joinRoom(roomUrl, joinToken);

        // Creo il linstner per gli eventi siri_transcription
        if(!chat) {
            chat = new VisitaChat(signaller_url, {
                container: '.chat-container'
            });

            let joinOptions = {
                room: 'deltacom',
                id: '1001'
            };

            await chat.socket.emit('join', joinOptions);
        } else {
            console.log("Chat già inizializzata e connessa a Room");
        }

        // TODO: VERIFICARE SE E' NECESSARIO
        chat.socket.on('siri_transcription', (data) => {
            // console.log("[deltaCom] 🎙️ Trascrizione ricevuta da Siri/Whisper:", {
            //     timestamp: new Date().toISOString(),
            //     participantId: data.participantId || 'N/A',
            //     text: data.text || data.message || data,
            //     textLength: (data.text || data.message || data).length,
            //     fullData: data
            // });
            gestisciSiriTranscription(data);
        });
    }
}


function aCapoAlPunto(text) {
    let newText = text.replace(/\.\.\./g, "&hellip;");
    newText = newText.replace(/\./g, ".<br>");
    return newText;
}


function indexOfWithSynonims(text, keywordList) {

    for (const keyword of keywordList) {
        let positionFound = text.indexOf(keyword);
        if (positionFound !== -1) {
            return positionFound;
        }
    }

    return -1;
}

function includeWithSynonims(text, keywordList) {

    for (const keyword of keywordList) {
        if(text.includes(keyword)) {
            return true;
        }
    }

    return false;

}


// TODO: Fare la indexOfWithSynonims
function getStartPositionOfCommand(text, activationCommand) {
    let positionFound = text.indexOf(activationCommand);
    return positionFound;
}

// Riceve il sinonimo del comando e restituisce la posizione della fine del comando
function getEndPositionOfCommand(text, detectedCommand, activationCommandPosition = null) {

    let textAfterActivationCommand = text.slice(activationCommandPosition);

    // let positionFound = textAfterActivationCommand.indexOf(detectedCommand) + activationCommandPosition;
    let positionFound = indexOfWithSynonims(textAfterActivationCommand, detectedCommand) + activationCommandPosition;
    return positionFound + detectedCommand.length;
}


function getTriagingText(text, detectedCommand, activationCommand) {

    let positionFound = text.indexOf(detectedCommand);
    let activatioPositionFound = text.indexOf(activationCommand);

    if(positionFound !== -1) {
        for (const command in commandMap) {
            positionFound = text.indexOf(detectedCommand);
            if (positionFound !== -1) {
                break;
            }
        }
    }

    if(detectedCommand === "inizia triage") {
        return text.slice(positionFound + detectedCommand.length);
    } 

    if(detectedCommand === "termina triage") {
        return text.slice(0, activatioPositionFound);
    }

    return text;
}




function processText(text, commandPositionStart, commandPositionEnd) {

    let processedText = text;
    let startTriageIcon = '&lang;&lang;&nbsp;';
    let endTriageIcon = '&nbsp;&rang;&rang;';
    // let startTriageIcon = '';
    // let endTriageIcon = '';

    if(commandPositionStart != null && commandPositionEnd != null) {
        let processedText_part0 = text.slice(0, commandPositionStart);
        let processedText_part1 = text.slice(commandPositionStart, commandPositionEnd);
        let processedText_part2 = text.slice(commandPositionEnd);

        // console.log("v-------------------------------v");
        // console.log("Parte 0: ", processedText_part0);
        // console.log("Parte 1: ", processedText_part1);
        // console.log("Parte 2: ", processedText_part2);
        // console.log("^-------------------------------^");

        if(includeWithSynonims(processedText_part1, commandMap["inizia triage"])) {
            processedText = 
                processedText_part0 + "<br><br><b>" + processedText_part1 + "</b><br><br>"+startTriageIcon + processedText_part2;
        } else if(includeWithSynonims(processedText_part1, commandMap["termina triage"])) {
            processedText = processedText_part0 +endTriageIcon+ "<br><br><b>" + processedText_part1 + "</b><br><br>" + processedText_part2;
        } else {
            processedText = processedText_part0 + "<br><br><b>" + processedText_part1 + "</b><br><br>" + processedText_part2;
        }
    }

    processedText = aCapoAlPunto(processedText);

    return processedText;

}


function gestisciMessaggioTrascrizione(messaggio, username = null) {

    if(isAIAllucinations(messaggio))
        return;

    let transcriptionText = messaggio;
    let msgTimestamp = now();
    let msgSpeaker = username;

    let commandPositionStart = null;
    let commandPositionEnd = null;

    let activationCommand = getActivationCommand(transcriptionText);            // Se presente, restituisce il comando di attivazione, altrimenti false
    let detectedCommand = getCommandAfterActivation(transcriptionText);         // Se presente, restituisce il comando rilevato, altrimenti false
    let rawDetectedCommand = getRawCommandAfterActivation(transcriptionText);   // Se presente, restituisce il comando rilevato originale, non convertendo il sinonimo, altrimenti false

    if((activationCommand != false) && detectedCommand) {
        // console.log("[deltaCom] ✅ Comando vocale identificato nella trascrizione:", {
        //     timestamp: new Date().toISOString(),
        //     activationKeyword: activationCommand,
        //     detectedCommand: detectedCommand,
        //     rawCommand: rawDetectedCommand,
        //     fullTranscription: transcriptionText,
        //     useS2TAScript: useS2TAScript
        // });

        // TODO: ATTIVARE PER SCRIPT ORIGINALE
        if(!useS2TAScript)
            handleDetectedCommand(detectedCommand);

        commandPositionStart = getStartPositionOfCommand(transcriptionText, activationCommand);
        commandPositionEnd = getEndPositionOfCommand(transcriptionText, rawDetectedCommand, commandPositionStart+activationCommand.length);

        // console.log("Posizione inizio comando: ", commandPositionStart);
        // console.log("Posizione fine comando: ", commandPositionEnd);

    }

    let processedTranscription = processText(transcriptionText, commandPositionStart, commandPositionEnd);

    let transcriptionContainer = document.getElementById("transcriptionContainer");
    let transcriptionBody = document.getElementById("transcriptionBody");
    let transcriptionBodyOperatorOnly = document.getElementById("transcriptionBodyOperatorOnly");
    let triageBodyOperatorOnly = document.getElementById("triageBodyOperatorOnly");
    let rawTranscription = document.getElementById("rawTranscription");




    // Creo la struttura HTML per la trascrizione
    let transcriptionRowStart = activationCommand ? `<div class="row" style="background-color: aliceblue; margin-right: 0px!important; font-weight: 700;">` : `<div class="row" style="margin-right: 0px!important;">`;
    let transcriptionRowEnd = `</div>`;

    let transcriptionTextUser = `<div class="col-3"><span style="color: cornflowerblue; font-size: smaller; ">${msgSpeaker}</span></div>`;
    let transcriptionTextTimestamp = `<div class="col-3"><span style="color: darkgray; font-size: smaller; ">${msgTimestamp}</span></div>`;
    let transcriptionTextFormatted = transcriptionRowStart+transcriptionTextUser+ '<div class="col-6">'+transcriptionText + "</div>" + transcriptionTextTimestamp + transcriptionRowEnd;

    // Mostro il box che mostra la trascrizione
    transcriptionContainer.style.display = "inline";

    // Aggiungo il testo al box che mostra la trascrizione
    transcriptionBody.innerHTML += transcriptionTextFormatted;

    let StylePrefix = "";
    let StylePostfix = "";

    if(msgSpeaker !== "Control Room") {

        // Aggiungo il testo grezzo alla trascrizione
        rawTranscription.value += transcriptionText + " ";

        // Analizzo con S2TAScript
        if(useS2TAScript){
            analizzaTrascrizione(rawTranscription.value, false);
            transcriptionBodyOperatorOnly.innerHTML = testoAI;
        }

        if(detectedCommand && (detectedCommand === "inizia triage" || detectedCommand === "termina triage")) {
            // GESTISCE INIZIO E FINE TRIAGE, SENZA TRALASCIARE IL TESTO
            if(!useS2TAScript){

                let triagingText = getTriagingText(transcriptionText, detectedCommand, activationCommand);
                triageBodyOperatorOnly.innerHTML += triagingText+" ";
            }
            // console.log("**** Testo triaging: ", triagingText);
        } else {

            if(isTriaging) {
                // GESTISCE LA PARTE CENTRALE DEL TRIAGE
                if(!useS2TAScript){
                    let triagingText = transcriptionText;
                    triageBodyOperatorOnly.innerHTML += triagingText+" ";
                }
                // console.log("--- Testo triaging: ", triagingText);
            }
        }

        if(!useS2TAScript){
            transcriptionBodyOperatorOnly.innerHTML += StylePrefix+processedTranscription+" "+StylePostfix;
        }

    }

    scrollToBottom();

}

function isAIAllucinations(messaggio) {
        let textToCheck = messaggio;
        for (let i = 0; i < AIAllucinations.length; i++) {
            if (textToCheck.includes(AIAllucinations[i])) {
                return true;
            }
        }

        return false;

}

    /********************************** */
    /*********   GPT HANDLERS   ******* */
    /********************************** */

    async function getGPTResponse(prompt = null, callback = null) {


        if(!prompt) {
            prompt = "Come ti chiami ?";
        }

        const temperature = parseFloat("0.2");

        // console.log("Prompt richiesta:\n" + prompt + "\n");

        try {
            const response = await axios.post(
                "https://api.openai.com/v1/chat/completions",
                {
                    //model: "gpt-3.5-turbo",
                    model: "gpt-4",
                    messages: [{ role: "user", content: prompt }],
                    temperature: temperature,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${apiKey}`,
                        "OpenAI-Organization": organizationID,
                    },
                }
            );
    
            // console.log("Risposta ricevuta:\n" + response.data.choices[0].message.content + "\n");
            return response.data.choices[0].message.content;
    
        } catch (err) {
            console.error(err);
            throw err;
        }

    }


/****************************** */
/********** COMMANDS  ********* */
/****************************** */

function getActivationCommand(text) {
    // Ritorna true se qualche parola chiave è inclusa nel testo e se il comando che segue è tra quelli supportati
    let textToCheck = text.toLowerCase();
    let activationFound = false;
    let activationPosition = -1;
    let activationKeywordFound = null;

    const startTime = performance.now();

    let activationRecognized = activationKeywordsList.some(keyword => textToCheck.includes(keyword));

    // TODO: Da testare insieme al for commentato successivo
    // Verifica che almeno l'80% delle lettere della parola chiave di attivazione corrisponda
    // if(!activationRecognized) {
    //     activationRecognized = activationKeywordsList.some(keyword => isSimilar(textToCheck, keyword));
    // }

    if(activationRecognized) {

        for (let activationKeyword of activationKeywordsList) {
            let position = textToCheck.indexOf(activationKeyword);
            if (position !== -1) {
                activationFound = true;
                activationKeywordFound = activationKeyword;
                activationPosition = position + activationKeyword.length; // Posizione dopo la parola chiave di attivazione
                break;
            }
        }

        // TODO: Da testare, spostare in una funzione che restituisce un oggetto con i valori trovati
        // Verifica che almeno l'80% delle lettere della parola chiave di attivazione corrisponda
        // for (let activationKeyword of activationKeywordsList) {
        //     let matchingChars = 0;
        //     const minLength = Math.min(textToCheck.length, activationKeyword.length);
        //     const minMatchLength = Math.ceil(0.8 * minLength);
        
        //     for (let i = 0; i < minLength; i++) {
        //         if (textToCheck[i] === activationKeyword[i]) {
        //             matchingChars++;
        //         }
        //     }
        
        //     if (matchingChars >= minMatchLength) {
        //         activationFound = true;
        //         activationKeywordFound = activationKeyword;
        //         activationPosition = textToCheck.indexOf(activationKeyword) + activationKeyword.length; // Posizione dopo la parola chiave di attivazione
        //         break;
        //     }
        // }

        let subsequentText = textToCheck.slice(activationPosition); // Testo successivo alla parola di attivazione
        for (let key in commandMap) {
            for (let command of commandMap[key]) {
                if (subsequentText.includes(command)) {
                    return activationKeywordFound; // Restituisci il comando di attivazione trovato (es. "comando smart")
                }
            }
        }

        return false;

    } else {
        return false;
    }

}

function getCommandAfterActivation(text) {
    let textToCheck = text.toLowerCase();
    let activationFound = false;
    let activationPosition = -1;

    // Trova il primo testo di attivazione nel testo
    for (let activationKeyword of activationKeywordsList) {
        let position = textToCheck.indexOf(activationKeyword);
        if (position !== -1) {
            activationFound = true;
            activationPosition = position + activationKeyword.length; // Posizione dopo la parola chiave di attivazione
            break;
        }
    }

    // Se è stata trovata una parola di attivazione, cerca i comandi nel testo successivo
    if (activationFound) {
        let subsequentText = textToCheck.slice(activationPosition); // Testo successivo alla parola di attivazione
        for (let key in commandMap) {
            for (let command of commandMap[key]) {
                if (subsequentText.includes(command)) {
                    return key; // Restituisci la chiave del comando trovato
                }
            }
        }
    }

    return null; // Nessun comando trovato dopo la parola di attivazione
}

function getRawCommandAfterActivation(text) {
    let textToCheck = text.toLowerCase();
    let activationFound = false;
    let activationPosition = -1;

    // Trova il primo testo di attivazione nel testo
    for (let activationKeyword of activationKeywordsList) {
        let position = textToCheck.indexOf(activationKeyword);
        if (position !== -1) {
            activationFound = true;
            activationPosition = position + activationKeyword.length; // Posizione dopo la parola chiave di attivazione
            break;
        }
    }

    // Se è stata trovata una parola di attivazione, cerca i comandi nel testo successivo
    if (activationFound) {
        let subsequentText = textToCheck.slice(activationPosition); // Testo successivo alla parola di attivazione
        for (let key in commandMap) {
            for (let command of commandMap[key]) {
                if (subsequentText.includes(command)) {
                    return command; // Restituisci la chiave del comando trovato
                }
            }
        }
    }

    return false; // Nessun comando trovato dopo la parola di attivazione
}

async function getSocketChat() {

    signaller_url = getAdminTokenBTN.getAttribute('data-signaller-url');

    if(!chat) {
        // console.log("[deltaCom] 🔌 Inizializzazione Socket.IO Chat:", {
        //     timestamp: new Date().toISOString(),
        //     signallerUrl: signaller_url,
        //     chatType: 'VisitaChat'
        // });

        chat = new VisitaChat(signaller_url, {
            container: '.chat-container'
        });

        let joinOptions = {
            room: 'deltacom',
            id: '1001'
        };

        // console.log("[deltaCom] 📤 Invio comando 'join' alla room:", joinOptions);
        await chat.socket.emit('join', joinOptions);
        // console.log("[deltaCom] ✅ Join alla room inviato con successo");
    } else {
        // console.log("[deltaCom] ♻️ Riutilizzo connessione Socket.IO esistente", {
        //     socketId: chat.socket?.id || 'N/A'
        // });
    }

    return chat;
}


async function handleDetectedCommand(command) {
    // console.log("[deltaCom] 🎯 Comando vocale rilevato e in invio sul socket:", {
    //     timestamp: new Date().toISOString(),
    //     command: command,
    //     commandType: typeof command,
    //     socketId: chat?.socket?.id || 'N/A'
    // });

    let chat = await getSocketChat();

    // Comunico il comando individuato sul socket
    // console.log("[deltaCom] 📤 Invio comando 'detected_command' al socket:", command);
    chat.socket.emit('detected_command', command);

    // Gestisco il comando
    switch (command) {
        case "scatta foto":
            handleScattaFoto();
            break;
        case "foto panoramica":
            handleFotoPanoramica();
            break;
        case "accendi torcia":
            handleAccendiTorcia();
            break;
        case "spegni torcia":
            handleSpegniTorcia();
            break;
        case "inizia triage":
            handleIniziaTriage();
            break;
        case "termina triage":
            handleTerminaTriage();
            break;
        case "conteggio pazienti":
            handleConteggioPazienti();
            break;
        case "cerca su internet":
            handleCercaSuInternet();
            break;
        case "chiedi all'ai":
            handleChiediAllAI();
            break;
        case "elenco comandi":
            handleElencoComandi();
            break;

        default:
            console.log("Comando non riconosciuto");
    }

}


/****************************** */
/***** COMMANDS HANDLERS ****** */
/****************************** */

function handleScattaFoto() {
    let commandName = "Scatta foto";
    showCommandFeedback(commandName);
    console.log(commandName);
}

function handleFotoPanoramica() {
    console.log("Foto panoramica");
}

function handleAccendiTorcia() {
    let commandName = "Accendi torcia";
    showCommandFeedback(commandName);
    console.log(commandName);
}

function handleSpegniTorcia() {
    let commandName = "Spegni torcia";
    showCommandFeedback(commandName);
    console.log(commandName);
}

function handleIniziaTriage() {

    let iniziaTriageBTN = document.getElementById('iniziaTriageBTN');
    //iniziaTriageBTN.style.display = "none";

    let terminaTriageBTN = document.getElementById('terminaTriageBTN');
    terminaTriageBTN.style.display = "inline";

    isTriaging = true;

    let commandName = "Inizia triage";
    showCommandFeedback(commandName);
    console.log(commandName);

}

function handleTerminaTriage() {

    let terminaTriageBTN = document.getElementById('terminaTriageBTN');
    //terminaTriageBTN.style.display = "none";

    let triageTableBTN = document.getElementById('triageTableBTN');
    triageTableBTN.style.display = "inline";

    isTriaging = false;

    let commandName = "Termina triage";
    showCommandFeedback(commandName);
    console.log(commandName);

}


async function handleSaveTranscription() {
    console.log("Salva trascrizione handler");

    await saveLastDailycoVideo();


    let saveTranscriptionBTN = document.getElementById('saveTranscriptionBTN');
    let token = saveTranscriptionBTN.getAttribute('data-jwt-token');
    let baseURL = saveTranscriptionBTN.getAttribute('data-base-url');
    let contextKey = document.getElementById('contextKey').value;
    let rawTranscription = document.getElementById('rawTranscription').value;
    let transcriptionBodyOperatorOnly = document.getElementById('transcriptionBodyOperatorOnly').innerHTML;
    let siriTranscription = document.getElementById('siriTranscriptionBody').innerHTML

    if (!transcriptionBodyOperatorOnly) {
        console.info("Nessuna trascrizione da salvare");
        return;
    }

    // Recupera tutti i media dalla pagina
    const mediaElements = document.querySelectorAll('.DeltacomMedia');
    const media = Array.from(mediaElements).map(element => {
        // Elimina tutti gli elementi <img> dall'elemento
        const clone = element.cloneNode(true);
        // Prendi il contenuto HTML rimanente e utilizzalo come campo raw
        return { raw: clone.innerHTML.trim() };
    });

    // URL dell'API
    const url = baseURL + '/api/deltacom-transcription/store';

    // Dati da inviare, includendo i media
    const data = {
        raw: transcriptionBodyOperatorOnly,
        context_key: contextKey,
        media: media,
        siri_trascription: siriTranscription
    };

    const config = {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    };

    axios.post(url, data, config)
        .then(response => {
            console.log('Success:', response.data);
        })
        .catch(error => {
            console.error('Error:', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                console.error('Response status:', error.response.status);
                console.error('Response headers:', error.response.headers);
            }
        });
}


function writeTextInRawTranscription(text) {
    let rawTranscription = document.getElementById('rawTranscription');
    rawTranscription.value = rawTranscription.value+" "+text+" ";
}

async function saveLastDailycoVideo() {
    const DAILY_API_KEY = "a15a590fd680c79e966177e3be2fadb4f11bdadc81ce1f4e26c18f98e80f14fa";

    // URL dell'API
    const url = 'https://api.daily.co/v1/recordings';

    const config = {
        headers: {
            'Authorization': `Bearer ${DAILY_API_KEY}`,
            'Content-Type': 'application/json'
        }
    };

     axios.get(url, config).then(async response => {

         let lastRecording = response.data.data[0];
         let lastRecordingId = lastRecording.id;
        //  console.log('Last Recording ID:', lastRecordingId);

        //  await getLastDailycoVideoAccesslink(lastRecordingId);
        await saveDeltacomRecording(lastRecordingId);

      })
         .catch(error => {
             console.error('Error:', error);
             if (error.response) {
                     console.error('Response data:', error.response.data);
                     console.error('Response status:', error.response.status);
                     console.error('Response headers:', error.response.headers);
             }
         }
     );

     return null;
}

async function saveDeltacomRecording(videoURL) {

    let storeAPIdata = document.getElementById('storeAPIdata');
    let token = storeAPIdata.getAttribute('data-jwt-token');
    let baseURL = storeAPIdata.getAttribute('data-base-url');
    let contextKey = document.getElementById('contextKey').value;

    // URL dell'API
    const url = baseURL + '/api/deltacom-transcription/store';

    // Dati da inviare, includendo i media
    const data = {
        video_url: videoURL,
        context_key: contextKey
    };

    const config = {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    };

    axios.post(url, data, config)
        .then(response => {
            console.log('Success:', response.data);
        })
        .catch(error => {
            console.error('Error:', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                console.error('Response status:', error.response.status);
                console.error('Response headers:', error.response.headers);
            }
        });
}


function addNewMediaElement(title, response) {

    // Response cleaning
    // Rimuovo eventuali intestazioni html che genera LLM
    response = response.replace("```html", '');
    response = response.replace("```", '');

    let mediaRow = document.getElementById('deltacomMediaRow');
    let rowPrefix = `<div class="media-col-3 mediaElementColoumn" style="border: 1px solid lightgrey; padding: 8px; border-radius: 8px;">`
    rowPrefix += `<div class="DeltacomMedia">`;
    rowPrefix += `<div class="deltacom-media-title">`+title+`</div>`;
    rowPrefix += `<div >`;
    let rowSuffix = `</div></div></div>`;

    mediaRow.innerHTML += rowPrefix + response + rowSuffix;

}

async function handleConteggioPazienti(requiredSelection = false) {

    console.log("Effettuo il Conteggio pazienti");
    let commandName = "Conteggio pazienti";
    showCommandFeedback(commandName);

    let selectedText = window.getSelection().toString();
    let transcriptionBodyOperatorOnly = document.getElementById('transcriptionBodyOperatorOnly');

    // Verifico se è requiredSelection è true, allora il testo selezionato è obbligatorio
    if(requiredSelection && !selectedText) {
        console.log("Nessun testo selezionato");
        alert("Nessun testo selezionato. Selezionare il testo da analizzare.");
        return "Nessun testo selezionato";
    }

    // Verifica se è stato selezionato del testo all'interno di transcriptionBodyOperatorOnly
    let prompt;

    if(transcriptionBodyOperatorOnly.innerHTML === "") {
        console.log("Nessun testo da analizzare");
        return "Nessun testo da analizzare";
    }

    // Controllo che il testo selezionato, sia parte di quello presente in transcriptionBodyOperatorOnly
    if (selectedText) {
        prompt = promptsMap["countPatients"][0] + " " + selectedText;
    } else {
        prompt = promptsMap["countPatients"][0] + " " + transcriptionBodyOperatorOnly.innerHTML;
    }

    let response = await getGPTResponse(prompt);
    // console.log("Risposta ricevuta: ", response);

    addNewMediaElement("Conteggio pazienti",response);

}


async function handleTableTriage(requiredSelection = false) {

    console.log("Generazione Table Triage");
    let commandName = "Tabella triage";
    showCommandFeedback(commandName);

    // let triageTableBTN = document.getElementById('triageTableBTN');
    // triageTableBTN.style.display = "none";
    let iniziaTriageBTN = document.getElementById('iniziaTriageBTN');
    iniziaTriageBTN.style.display = "inline";

    let triageBodyOperatorOnly = document.getElementById('triageBodyOperatorOnly');

    // Verifica se è stato selezionato del testo all'interno di transcriptionBodyOperatorOnly
    let selectedText = window.getSelection().toString();

    // Verifico se è requiredSelection è true, allora il testo selezionato è obbligatorio
    if(requiredSelection && !selectedText) {
        console.log("Nessun testo selezionato");
        alert("Nessun testo selezionato. Selezionare il testo da analizzare.");
        return "Nessun testo selezionato";
    }

    let prompt;

    if(triageBodyOperatorOnly.innerHTML === "") {
        console.log("Nessun testo da analizzare");
        return "Nessun testo da analizzare";
    }

    // Se c'è del testo selezionato, uso quello per il prompt
    if (selectedText) {
        prompt = promptsMap["triageTable"][0] + " " + selectedText;
    } else {
        prompt = promptsMap["triageTable"][0] + " " + triageBodyOperatorOnly.innerHTML;
    }

    let response = await getGPTResponse(prompt);
    // console.log("Risposta ricevuta: ", response);

    addNewMediaElement("Triage", response);

}

async function handleSessionRelationship(requiredSelection = false) {

    let commandName = "Relazione sulla sessione";
    showCommandFeedback(commandName);
    console.log(commandName);

    let rawTranscription = document.getElementById('transcriptionBodyOperatorOnly');

    // Verifica se è stato selezionato del testo all'interno di rawTranscription
    let selectedText = window.getSelection().toString();

    // Verifico se è requiredSelection è true, allora il testo selezionato è obbligatorio
    if(requiredSelection && !selectedText) {
        console.log("Nessun testo selezionato");
        alert("Nessun testo selezionato. Selezionare il testo da analizzare.");
        return "Nessun testo selezionato";
    }

    let prompt;

    if(rawTranscription.innerHTML === "") {
        console.log("Nessun testo da analizzare");
        return "Nessun testo da analizzare";
    }

    // Controllo che il testo selezionato, sia parte di quello presente in rawTranscription
    if (selectedText) {
        prompt = promptsMap["sessionRelationship"][0] + " " + selectedText;
    } else {
        prompt = promptsMap["sessionRelationship"][0] + " " + rawTranscription.innerHTML;
    }

    let response = await getGPTResponse(prompt);
    // console.log("Risposta ricevuta: ", response);

    addNewMediaElement("Relazione sessione", response);

}


function handleCercaSuInternet() {
    console.log("Cerca su internet handler");
}

function handleChiediAllAI() {
    console.log("Chiedi all'AI handler");
}

async function handleElencoComandi() {

    let commandName = "Elenco comandi";
    showCommandFeedback(commandName);
    console.log(commandName);

    let chat = await getSocketChat();

    chat.socket.emit('command_list', JSON.stringify(elencoComandi));
    // chat.socket.broadcast.emit('command_list', JSON.stringify(elencoComandi));

}





/****************************** */
/********** UTILS  ********* */
/****************************** */
function showCommandFeedback(commandName) {
    let lastCommandContainer = document.getElementById('lastCommandContainer');
    let commandIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="green" class="bi bi-circle-fill" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8"/></svg>';
    lastCommandContainer.innerHTML = commandIcon+'&nbsp;<strong class="me-auto">&nbsp;'+commandName+'</strong>';

    fadeLastCommand();
}

function fadeLastCommand() {
    let lastCommandContainer = document.getElementById('lastCommandContainer');

    // Imposta un timer per applicare la classe fade-out dopo 3 secondi
    lastCommandContainer.classList.remove('fade-out');
    lastCommandContainer.classList.add('fade-in');

    // Rimuovi la classe fade-in e aggiungi fade-out dopo 3 secondi
    setTimeout(() => {
        lastCommandContainer.classList.remove('fade-in');
        lastCommandContainer.classList.add('fade-out');

        // Opzionale: rimuovi il contenuto dall'elemento dopo che il fade out è completo
        setTimeout(() => {
            lastCommandContainer.innerHTML = "";
        }, 1000); // Assicurati che questo coincida con la durata dell'animazione fade-out

    }, 4000); // Totale di 4 secondi (1s fade-in + 3s mostrato)
}

function gestisciSiriTranscription(data) {
    let transcriptionText = data.transcription;

    let siriTranscriptionContainer = document.getElementById("siriTranscriptionContainer");
    let siriTranscriptionBody = document.getElementById("siriTranscriptionBody");

    siriTranscriptionBody.innerHTML = transcriptionText;
    //siriTranscriptionContainer.style.display = "inline";

}

function isSimilar(word1, word2) {

    // Calcola la lunghezza minima tra le due parole

    // Misuro le performance
    const startTime = performance.now();

    // Calcola la lunghezza minima tra le due parole
    const minLength = Math.min(word1.length, word2.length);
    // Calcola il numero minimo di caratteri che devono coincidere per considerare le parole simili
    const minMatchLength = Math.ceil(0.8 * minLength);

    // Conta il numero di caratteri che coincidono tra le due parole
    let matchingChars = 0;
    for (let i = 0; i < minLength; i++) {
        if (word1[i] === word2[i]) {
            matchingChars++;
        }
    }

    if(matchingChars >= minMatchLength) {
        console.log("Parole simili: ", word1, word2);
        const endTime = performance.now();

        // Calcola il tempo di esecuzione in millisecondi
        const executionTime = endTime - startTime;
    
        // Output del tempo di esecuzione
        console.log("Tempo di esecuzione:", executionTime, "millisecondi");
    }
    // Restituisce true se il numero di caratteri che coincidono è maggiore o uguale al minimo richiesto
    return matchingChars >= minMatchLength;
}

function formatTime(timestamp) {
    // Crea un oggetto Date dal timestamp
    const date = new Date(timestamp);

    // Estrae ore, minuti e secondi
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    // Formatta in hh:mm:ss
    return `${hours}:${minutes}:${seconds}`;
}

function now() {

    // Crea un oggetto Date dal timestamp
    const date = new Date();

    // Estrae ore, minuti e secondi
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    // Formatta in hh:mm:ss
    return `${hours}:${minutes}:${seconds}`;

}

function scrollToBottom() {
    var transcriptionBodyOperatorOnly = document.getElementById("transcriptionBodyOperatorOnly");
    transcriptionBodyOperatorOnly.scrollTop = transcriptionBodyOperatorOnly.scrollHeight;
    var siriTranscriptionBody = document.getElementById("siriTranscriptionBody");
    siriTranscriptionBody.scrollTop = siriTranscriptionBody.scrollHeight;
}


/****************************** */
/********** LISTENERS ********* */
/****************************** */
document.addEventListener('DOMContentLoaded', async () => {

    // Se non è presente il pulsante di ottenimento del token, esco
    if( document.getElementById('getAdminTokenBTN') == null)
        return;

    var getAdminTokenBTN = document.getElementById('getAdminTokenBTN');
    var cameraIcon = document.getElementById('camera-icon');
    var cameraSelector = document.getElementById('camera-selector');
    var micIcon = document.getElementById('mic-icon');
    var micSelector = document.getElementById('mic-selector');
    var joinBTN = document.getElementById('joinBTN')

    var toggleCamera = document.getElementById('toggle-camera');
    var toggleMic = document.getElementById('toggle-mic');

    var countPatientsBTN = document.getElementById('countPatientsBTN');
    var triageTableBTN = document.getElementById('triageTableBTN');
    var sessionRelationshipBTN = document.getElementById('sessionRelationshipBTN');


    var iniziaTriageBTN = document.getElementById('iniziaTriageBTN');
    var terminaTriageBTN = document.getElementById('terminaTriageBTN');

    var commandsListBTN = document.getElementById('commandsListBTN');
    var closeModalElencoComandiBTN = document.getElementById('closeModalElencoComandiBTN');
    // var takePictureBTN = document.getElementById('takePictureBTN');
    var flashlightOnBTN = document.getElementById('flashlightOnBTN');
    var flashlightOffBTN = document.getElementById('flashlightOffBTN');

    var saveTranscriptionBTN = document.getElementById('saveTranscriptionBTN');


    // Aggiungo i listener ai pulsanti
    getAdminTokenBTN.addEventListener('click', function() {
        // console.log("getAdminTokenBTN cliccato");
        signaller_url = getAdminTokenBTN.getAttribute('data-signaller-url');
        getAdminToken();
    });

    micIcon.addEventListener('click', function() {
        // Toggle the display CSS property
        micSelector.style.display = micSelector.style.display === 'none' ? 'block' : 'none';
    });

    cameraIcon.addEventListener('click', function() {
        // Toggle the display CSS property
        cameraSelector.style.display = cameraSelector.style.display === 'none' ? 'block' : 'none';
    });

    // Close the dropdown when clicking outside of it
    document.addEventListener('click', function(event) {
        if (!cameraIcon.contains(event.target) && !cameraSelector.contains(event.target)) {
            cameraSelector.style.display = 'none';
        }
    });

    // Close the dropdown when clicking outside of it
    document.addEventListener('click', function(event) {
        if (!micIcon.contains(event.target) && !micSelector.contains(event.target)) {
            micSelector.style.display = 'none';
        }
    });

    joinBTN.addEventListener('click', async function () {
        const roomUrl = document.getElementById('roomURL').value.trim();
        const joinToken = document.getElementById('adminTokenContainer').value.trim() || null;

        document.getElementById('joinBTN').disabled = true;
        document.getElementById('joinBTN').style = 'display: none;';

        let videoCardContainer = document.getElementById('videoCardContainer');
        videoCardContainer.style.display = "block";

        // this.updateUIButtons(toggleCamera = null, toggleMic = null, cameraSelector = null, micSelector = null);
        dailyCallManager.updateUIButtons(false, false, false, false);

        await dailyCallManager.joinRoom(roomUrl, joinToken);

        // Creo il linstner per gli eventi siri_transcription
        if(!chat) {
            chat = new VisitaChat(signaller_url, {
                container: '.chat-container'
            });

            let joinOptions = {
                room: 'deltacom',
                id: '1001'
            };

            await chat.socket.emit('join', joinOptions);
        } else {
            console.log("Chat già inizializzata e connessa a Room");
        }

        // TODO: VERIFICARE SE E' NECESSARIO
        chat.socket.on('siri_transcription', (data) => {
            // console.log("[deltaCom] 🎙️ Trascrizione ricevuta da Siri/Whisper:", {
            //     timestamp: new Date().toISOString(),
            //     participantId: data.participantId || 'N/A',
            //     text: data.text || data.message || data,
            //     textLength: (data.text || data.message || data).length,
            //     fullData: data
            // });
            gestisciSiriTranscription(data);
        });

      });

    toggleCamera.addEventListener('click', function() {

        console.log("toggleCamera cliccato");
        dailyCallManager.toggleCamera()

        // Dopo aver cambiato lo stato, aggiorna l'icona in base al nuovo stato del microfono
        setTimeout(() => {  // Utilizzo un timeout per assicurarmi che lo stato sia aggiornato
            const cameraIsOn = dailyCallManager.call.localVideo(); // Assumi che questo metodo restituisca lo stato corrente del microfono

            // Seleziona l'elemento SVG all'interno del bottone
            const svgElement = this.querySelector('svg');
            
            // Aggiorna l'icona SVG e il colore in base allo stato del camera
            if (cameraIsOn) {
                svgElement.innerHTML = `<path fill-rule="evenodd" d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"/>`; // Icona camera on
                // svgElement.setAttribute('fill', 'green'); // Cambia il colore in verde
            } else {
                svgElement.innerHTML = `<path fill-rule="evenodd" d="M10.961 12.365a2 2 0 0 0 .522-1.103l3.11 1.382A1 1 0 0 0 16 11.731V4.269a1 1 0 0 0-1.406-.913l-3.111 1.382A2 2 0 0 0 9.5 3H4.272l.714 1H9.5a1 1 0 0 1 1 1v6a1 1 0 0 1-.144.518zM1.428 4.18A1 1 0 0 0 1 5v6a1 1 0 0 0 1 1h5.014l.714 1H2a2 2 0 0 1-2-2V5c0-.675.334-1.272.847-1.634zM15 11.73l-3.5-1.555v-4.35L15 4.269zm-4.407 3.56-10-14 .814-.58 10 14z"/>`; // Icona camera off
                // svgElement.setAttribute('fill', 'red'); // Cambia il colore in rosso
            }
        }, 5500);
    });

    toggleMic.addEventListener('click', function() {
        console.log("toggleMic cliccato");
        dailyCallManager.toggleMicrophone()

        // Dopo aver cambiato lo stato, aggiorna l'icona in base al nuovo stato del microfono
        setTimeout(() => {  // Utilizzo un timeout per assicurarmi che lo stato sia aggiornato
            const micIsOn = dailyCallManager.call.localAudio(); // Assumi che questo metodo restituisca lo stato corrente del microfono

            // Seleziona l'elemento SVG all'interno del bottone
            const svgElement = this.querySelector('svg');
            
            // Aggiorna l'icona SVG e il colore in base allo stato del microfono
            if (micIsOn) {
                svgElement.innerHTML = `<path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5"/>
                <path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3"/>`; // Icona mic on
                // svgElement.setAttribute('fill', 'green'); // Cambia il colore in verde
            } else {
                svgElement.innerHTML = `<path d="M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4 4 0 0 0 12 8V7a.5.5 0 0 1 1 0zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a5 5 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4m3-9v4.879l-1-1V3a2 2 0 0 0-3.997-.118l-.845-.845A3.001 3.001 0 0 1 11 3"/><path d="m9.486 10.607-.748-.748A2 2 0 0 1 6 8v-.878l-1-1V8a3 3 0 0 0 4.486 2.607m-7.84-9.253 12 12 .708-.708-12-12z"/>`; // Icona mic off
                // svgElement.setAttribute('fill', 'red'); // Cambia il colore in rosso
            }
        }, 100);
    });

    /*** AI BUTTONS LISTENERS *** */
    countPatientsBTN.addEventListener('click', async function() {
        handleConteggioPazienti();
        let chat = await getSocketChat();
        chat.socket.emit('detected_command', "conteggio pazienti");
    });
    triageTableBTN.addEventListener('click', async function() {
        handleTableTriage();
        let chat = await getSocketChat();
        chat.socket.emit('detected_command', "tabella triage");
    });
    sessionRelationshipBTN.addEventListener('click', async function() {
        handleSessionRelationship();
        let chat = await getSocketChat();
        chat.socket.emit('detected_command', "relazione sulla sessione");
    });

    iniziaTriageBTN.addEventListener('click', async function() {
        handleIniziaTriage();

        if(useS2TAScript){
            writeTextInRawTranscription("comando smart inizia triage");
            // Forzo l'analisi della trascrizione
            let rawTranscription = document.getElementById('rawTranscription');
            analizzaTrascrizione(rawTranscription.value, false);
        }

        let chat = await getSocketChat();
        chat.socket.emit('detected_command', "inizia triage");
    });
    terminaTriageBTN.addEventListener('click', async function() {
        handleTerminaTriage();

        if(useS2TAScript){
            writeTextInRawTranscription("comando smart termina triage");
            // Forzo l'analisi della trascrizione
            let rawTranscription = document.getElementById('rawTranscription');
            analizzaTrascrizione(rawTranscription.value, false);
        }

        // Invio il comando rilevato alla sul socket
        let chat = await getSocketChat();
        chat.socket.emit('detected_command', "termina triage");
    });

    /*** CONTROL ROOM BUTTONS *** */
    commandsListBTN.addEventListener('click', async function() {
        handleElencoComandi();

        let modalElencoComandi = document.getElementById("modalElencoComandi");
        modalElencoComandi.style.display = "block";

    });
    document.querySelector('.btn-close').addEventListener('click', function() {
        var modal = document.getElementById('modalElencoComandi');
        modal.style.display = 'none'; // Nasconde la modal cambiando il display a 'none'
    });

    closeModalElencoComandiBTN.addEventListener('click', function() {
        var modal = document.getElementById('modalElencoComandi');
        modal.style.display = 'none'; // Nasconde la modal cambiando il display a 'none'
    });
    
    // takePictureBTN.addEventListener('click', async function() {
    //     handleDetectedCommand("scatta foto");
    // });
    flashlightOnBTN.addEventListener('click', async function() {
        handleDetectedCommand("accendi torcia");
    });
    flashlightOffBTN.addEventListener('click', async function() {
        handleDetectedCommand("spegni torcia");
    });

    /************************************************ */
    // Creo un'istanza della classe DailyCallManager
    /************************************************ */
    if(!dailyCallManager){
        dailyCallManager = new DailyCallManager();
        dailyCallManager.setupDeviceSelectors();
    }  
    // document
    //   .getElementById('transcribe-btn')
    //   .addEventListener('click', async function () {
    //     dailyCallManager.transcribeAudio = !dailyCallManager.transcribeAudio;
    //     document.getElementById('transcribe-btn').textContent = dailyCallManager.transcribeAudio
    //       ? 'Stop Transcribing'
    //       : 'Start Transcribing';
    //     });

    // Associa le azioni di Join al tasto Play. Recupera l'url della stanza e il token di join, se presente.

  
    // Bind the leave call action to the leave button.
    document.getElementById('leave-btn').addEventListener('click', async function () {

        await dailyCallManager.terminaRegistrazione(); // Termina la registrazione
        dailyCallManager.updateRecordTranscribeButtons(false, false, false, false);
        dailyCallManager.leave(); // Termina la chiamata

        handleSaveTranscription(); // Salva la trascrizione corrente

    });

    // Avvia Registrazione Listner
    document.getElementById('avviaRegistrazioneBTN').addEventListener('click', async function () {

        // Aggiorno i tasti per la registrazione e lascio invairati quelli della trascrizione
        dailyCallManager.updateRecordTranscribeButtons(false, true, null, null);

        // Avvio la registrazione
        await dailyCallManager.avviaRegistrazione();

    });

    // Termina Registrazione Listner
    document.getElementById('terminaRegistrazioneBTN').addEventListener('click', async function () {

        // Aggiorno i tasti per la registrazione e lascio invairati quelli della trascrizione
        dailyCallManager.updateRecordTranscribeButtons(true, false, null, null);

        // Termina la registrazione
        await dailyCallManager.terminaRegistrazione();
    });

    // Salva Trascrizione corrente
    saveTranscriptionBTN.addEventListener('click', async function () {
        handleSaveTranscription();
    });

    initComandiSpot();

}); // DOMContentLoaded


/******************************** */
/* ******* JS S2TAScript ******** */
/******************************** */

function initComandiSpot() {

    let debugS2TAScript = false;

    Object.entries(commandMap).forEach(([key, sinonimi]) => {
        comandiSpot.push(key);                                      // Aggiunge il comando principale
        comandiSpot = comandiSpot.concat(sinonimi);                 // Aggiunge i sinonimi
    });
    if(debugS2TAScript)
        console.log("comandiSpot: ", comandiSpot);

    inizioTriageSinonimi = ["inizia triage"].concat(commandMap["inizia triage"]);

    if(debugS2TAScript)
        console.log("inizioTriageSinonimi:", inizioTriageSinonimi);

    fineTriageSinonimi = ["termina triage"].concat(commandMap["termina triage"]);

    if(debugS2TAScript)
        console.log("fineTriageSinonimi: ", fineTriageSinonimi);

    // Array dei possibili trigger
    triggerPossibili = activationKeywordsList;


}

// Funzione per pulire il testo da punteggiatura e spazi extra
function pulisciTesto(input) {
    return input.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, " ").replace(/\s{2,}/g, " ");
}

/*
// Funzione per trovare il comando esatto
function searchCommand(input) {
    const regex = new RegExp(`(${triggerPossibili.join("|")})\\s+((${comandiSpot.join("|")}))`, "i");
    const match = input.match(regex);
    return match ? match[2] : null;
}*/

// Funzione per analizzare la trascrizione e riconoscere i comandi
function analizzaTrascrizione(trascrizione, stampaLog = true) {

    const trascrizioneNonPulita = trascrizione

    trascrizione = pulisciTesto(trascrizione.toLowerCase());

    if (stampaLog) {
        console.log("Testo in ingresso: \n", trascrizione);
        console.log("ultimaPosizioneAnalizzataSpot", ultimaPosizioneAnalizzataSpot);
        console.log("Testo da analizzare: \n", trascrizione.slice(ultimaPosizioneAnalizzataSpot));
    }

    handleTextExtraction(trascrizione);

    const testoDaAnalizzare = trascrizione.slice(ultimaPosizioneAnalizzataSpot);

    //let testoDaIncrementare = trascrizioneNonPulita.slice(ultimaPosizioneAnalizzataSpot);
    let testoDaIncrementare = trascrizioneNonPulita.slice(ultimaPosizioneTestoAI);
    //console.log("testoDaIncrementare [", testoDaIncrementare+"]");

    const comandiSpotTrovati = searchMultipleCommandsSpot(testoDaAnalizzare);

    if (comandiSpotTrovati.length > 0) {
        comandiSpotTrovati.forEach((comando, index) => {
            if (stampaLog) {
                console.log("Comando riconosciuto:", comando.comando);
            }
            eseguiComandoSpot(comando.comando);

            if (index === comandiSpotTrovati.length - 1) {
                ultimaPosizioneAnalizzataSpot += comando.posizioneFine;
                ultimaPosizioneTestoAI = ultimaPosizioneAnalizzataSpot;
            }

 
            //aggiungo /n e formattazione necessaria

            const regex = new RegExp(pulisciTesto(comando.comando), "gi"); // ignora maiuscole e spazi extra
            // testoDaIncrementare = testoDaIncrementare.replace(regex, "\n\n" + comando.comando.toUpperCase() + "\n");
            // testoDaIncrementare = testoDaIncrementare.replace(/\n[.,;:!?\-()]+/g, "\n ");                               // rimuove punteggiatura dopo a capo

            testoDaIncrementare = testoDaIncrementare.replace(regex, "<br><br>" + comando.comando.toUpperCase() + "<br>");
            //testoDaIncrementare = testoDaIncrementare.replace(/\n[.,;:!?\-()]+/g, "<br> ");                               // rimuove punteggiatura dopo a capo
            testoDaIncrementare = testoDaIncrementare.replace(/<br>[.,;:!?\-()]+/g, "<br> ");                               // rimuove punteggiatura dopo a capo

           //console.log("testoDaIncrementare", testoDaIncrementare)

        });
    } else {
        if (stampaLog) {
            console.log("Nessun nuovo comando trovato");
        }

        //ultimaPosizioneAnalizzataSpot = trascrizione.length; // E' sato necessario decommentarlo, perchè altrimenti testoDaIncrementare manteneva anche la parte precedente
        ultimaPosizioneTestoAI = trascrizione.length;
    }

    // aggiungo spazi dopo punteggiatura 
    testoDaIncrementare = testoDaIncrementare.replace(/([,.])(?![\s])/g, "$1 ");

    //console.log("testoAI: [", testoAI+"]");
    //console.log("testoDaIncrementare: (", testoDaIncrementare+")");

    testoAI = testoAI + testoDaIncrementare;

    ultimaPosizioneTestoAI = testoAI.length;

}

// Funzione per trovare tutti i comandi nel testo da analizzare
function searchMultipleCommandsSpot(testo) {
    const regex = new RegExp(`(${triggerPossibili.join("|")})\\s+((${comandiSpot.join("|")}))`, "gi");
    let match;
    let comandi = [];

    while ((match = regex.exec(testo)) !== null) {
        comandi.push({
            comando: match[2],
            posizioneFine: match.index + match[0].length
        });
    }

    return comandi;
}

// Funzione per gestire l'estrazione del testo tra i comandi di triage
function handleTextExtraction(trascrizione) {

    //console.log("Testo in ingresso: \n", trascrizione);

    const testoDaAnalizzare = trascrizione.slice(ultimaPosizioneAnalizzataContinuos);
    const startIndex = findCommandIndex(testoDaAnalizzare, inizioTriageSinonimi);
    const endIndex = findCommandIndex(testoDaAnalizzare, fineTriageSinonimi);
   // console.log("Testo da analizzare: \n", testoDaAnalizzare);

    if (startIndex !== -1 && endIndex !== -1 && endIndex > startIndex) {
        const extractedText = testoDaAnalizzare.substring(startIndex, endIndex).trim();
        console.log("Testo estratto per triage:", extractedText);
        eseguiComandoTesto(extractedText)
        ultimaPosizioneAnalizzataContinuos += endIndex;
    }
}

 function findCommandIndex(testo, comandi) {
    let minIndex = -1;
    comandi.forEach(comando => {
        let idx = testo.indexOf(comando);
        if (idx !== -1 && (minIndex === -1 || idx < minIndex)) {
            minIndex = idx + comando.length;  
        }
    });
    return minIndex;
}

// questo metodo viene chiamato appena un prompt di triage viene rilevato
function eseguiComandoTesto(extractedText) {
    //console.log("*** Testo estratto X TRIAGE: ", extractedText);

    let triageBodyOperatorOnly = document.getElementById('triageBodyOperatorOnly');
    triageBodyOperatorOnly.innerHTML = extractedText;

}

// Funzione per eseguire i comandi come Accendi torcia, spegni torcia ecc ecc. Quindi tutti i comandi che nn richiedono un analisi del testo
function eseguiComandoSpot(comando) {
    //console.log("Esecuzione comando SPOT: ", comando);

    // Identifica a quale chiave di commandMap appartiene il comando
    let trovato = false;

    for (const [chiave, sinonimi] of Object.entries(commandMap)) {
        if (sinonimi.includes(comando)) {
            //console.log(`Il comando "${comando}" appartiene alla categoria "${chiave}".`);
            handleDetectedCommand(chiave)
            trovato = true;
            break;
        }
    }

     if (!trovato) {
         console.log("Comando non riconosciuto. Sinonimo non presente in commandMap");
     }

    }

/**
 * Aggiorna i dati dell'overlay per un operatore specifico
 * @param {string} participantId - ID del partecipante
 * @param {Object} data - Dati da aggiornare
 */
function updateOperatorOverlay(participantId, data) {
    const videoContainer = document.getElementById(`video-container-${participantId}`);
    if (!videoContainer) return;

    const overlay = videoContainer.querySelector('.video-overlay-custom');
    if (!overlay) return;

    // Aggiorna il nome dell'operatore
    const operatorName = overlay.querySelector('.operator-name');
    if (operatorName && data.operatorName) {
        operatorName.textContent = data.operatorName;
    }

    // Aggiorna i valori delle metriche SOLO con il valore puro
    const updateValue = (selector, value) => {
        const element = overlay.querySelector(selector);
        if (element && value !== undefined) {
            element.textContent = value;
        }
    };

    updateValue('.bpm-value', data.bpm);
    updateValue('.bpm-max-value', data.bpmMax);
    updateValue('.distance-value', data.distance);
    updateValue('.speed-value', data.speed);
    updateValue('.movement-value', data.movement);
    updateValue('.energy-value', data.energy);
}
